module.exports = __webpack_public_path__ + "static/media/express.b80d1fe5.svg";